export enum Constants {
  CAMPAIGNS_ADD_NEW_CAMPAIGN = 'CAMPAIGNS_ADD_NEW_CAMPAIGN',
  CAMPAIGNS_UPDATE_CAMPAIGNS = 'CAMPAIGNS_UPDATE_CAMPAIGNS',
  CAMPAIGNS_SET_LOADING = 'CAMPAIGNS_SET_LOADING'
}